// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data {
  height: 100vh;
  height: 100%;
  position: sticky;
  top: 0;
}
.data ion-col {
  padding-bottom: 25px;
}
.data .data-title {
  color: var(--ion-color-medium);
}
.data hr {
  margin-bottom: 24px;
  margin-top: 0;
}
.data ion-button ion-icon {
  font-size: 16px;
}
.data .title-ticket {
  margin-bottom: 13px;
}
.data .title-ticket h1 {
  font-size: 30px !important;
  font-weight: 600;
}
.data .title-ticket h1 span {
  font-size: 30px !important;
  font-weight: 600;
  color: var(--ion-color-primary);
}

.ticket-data {
  padding: 16px;
  height: 100vh;
  overflow-y: auto;
  background: var(--ion-color-light);
}
.ticket-data .payments ion-card-content {
  padding: 0 !important;
}
.ticket-data .payments ion-card-content ion-item {
  padding: 10px 0;
  padding-right: 10px;
}
.ticket-data .payments ion-card-content ion-item ion-icon {
  font-size: 27px;
}
.ticket-data .payments ion-card-content ion-item h3 {
  font-weight: 600;
  color: var(--ion-color-dark);
}
.ticket-data .payments ion-card-content ion-item ion-label {
  padding: 0;
}

ion-card {
  margin-bottom: 32px;
}
ion-card ion-card-header {
  border-bottom: 1px solid #f5f8fa;
}
ion-card ion-card-header ion-icon {
  font-size: 20px;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
  color: #a6a9ab;
}
ul li {
  font-size: 13px;
}

.send-mail ion-button {
  position: absolute;
  right: 0;
  --background: transparent !important;
}

.option {
  width: 100%;
  height: 100%;
  margin: 0;
  border: 1px solid #ebeff8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 20px;
  cursor: pointer;
  border-radius: 13px;
}
.option ion-icon {
  font-size: 55px;
  margin-bottom: 40px;
  color: #404248;
}
.option ion-label {
  font-size: 17px !important;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center;
  color: #404248;
  width: 70%;
}
.option--disabled {
  cursor: not-allowed;
}
.option--disabled ion-icon,
.option--disabled ion-label {
  color: #d5dae5;
}

@media (max-width: 767px) {
  .container {
    display: block !important;
  }
  .data {
    padding: 16px;
    width: 100% !important;
    position: relative !important;
  }
  .ticket-data {
    padding: 0;
    height: unset !important;
    width: 100% !important;
    position: relative !important;
    padding-bottom: env(safe-area-inset-bottom) !important;
  }
}
.giftcard {
  border-radius: 16px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: auto;
  background: linear-gradient(56deg, rgb(35, 107, 254) 35%, rgb(35, 159, 254) 100%);
  position: relative;
  margin-top: 16px;
  margin-bottom: 16px;
}
.giftcard .main-info h1 {
  font-weight: 600;
  color: white;
  font-size: 35px;
  letter-spacing: 6px;
}
.giftcard .main-info h2 {
  font-size: 20px;
  font-weight: 600;
  color: white;
  letter-spacing: 0.5px;
}
.giftcard .main-info p {
  color: rgba(255, 255, 255, 0.7490196078);
  font-size: 16px;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.giftcard .logo {
  position: absolute;
  right: 30px;
  width: 40px;
  filter: brightness(0) invert(1);
}`, "",{"version":3,"sources":["webpack://./src/app/components/payments/giftcard/giftcard.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,MAAA;AACF;AACE;EACE,oBAAA;AACJ;AAEE;EACE,8BAAA;AAAJ;AAGE;EACE,mBAAA;EACA,aAAA;AADJ;AAKI;EACE,eAAA;AAHN;AAOE;EACE,mBAAA;AALJ;AAOI;EACE,0BAAA;EACA,gBAAA;AALN;AAOM;EACE,0BAAA;EACA,gBAAA;EACA,+BAAA;AALR;;AAWA;EACE,aAAA;EACA,aAAA;EACA,gBAAA;EACA,kCAAA;AARF;AAWI;EACE,qBAAA;AATN;AAWM;EACE,eAAA;EACA,mBAAA;AATR;AAWQ;EACE,eAAA;AATV;AAYQ;EACE,gBAAA;EACA,4BAAA;AAVV;AAaQ;EACE,UAAA;AAXV;;AAkBA;EACE,mBAAA;AAfF;AAiBE;EACE,gCAAA;AAfJ;AAiBI;EACE,eAAA;AAfN;;AAoBA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;AAjBF;AAmBE;EACE,eAAA;AAjBJ;;AAsBE;EACE,kBAAA;EACA,QAAA;EACA,oCAAA;AAnBJ;;AAuBA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AApBF;AAsBE;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AApBJ;AAuBE;EACE,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AArBJ;AAwBE;EACE,mBAAA;AAtBJ;AAwBI;;EAEE,cAAA;AAtBN;;AA2BA;EACE;IACE,yBAAA;EAxBF;EA2BA;IACE,aAAA;IACA,sBAAA;IACA,6BAAA;EAzBF;EA4BA;IACE,UAAA;IACA,wBAAA;IACA,sBAAA;IACA,6BAAA;IACA,sDAAA;EA1BF;AACF;AA6BA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iFAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA3BF;AA8BI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AA5BN;AA+BI;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;AA7BN;AAgCI;EACE,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;AA9BN;AAkCE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,+BAAA;AAhCJ","sourcesContent":[".data {\n  height: 100vh;\n  height: 100%;\n  position: sticky;\n  top: 0;\n\n  ion-col {\n    padding-bottom: 25px;\n  }\n\n  .data-title {\n    color: var(--ion-color-medium);\n  }\n\n  hr {\n    margin-bottom: 24px;\n    margin-top: 0;\n  }\n\n  ion-button {\n    ion-icon {\n      font-size: 16px;\n    }\n  }\n\n  .title-ticket {\n    margin-bottom: 13px;\n\n    h1 {\n      font-size: 30px !important;\n      font-weight: 600;\n\n      span {\n        font-size: 30px !important;\n        font-weight: 600;\n        color: var(--ion-color-primary);\n      }\n    }\n  }\n}\n\n.ticket-data {\n  padding: 16px;\n  height: 100vh;\n  overflow-y: auto;\n  background: var(--ion-color-light);\n\n  .payments {\n    ion-card-content {\n      padding: 0 !important;\n\n      ion-item {\n        padding: 10px 0;\n        padding-right: 10px;\n\n        ion-icon {\n          font-size: 27px;\n        }\n\n        h3 {\n          font-weight: 600;\n          color: var(--ion-color-dark);\n        }\n\n        ion-label {\n          padding: 0;\n        }\n      }\n    }\n  }\n}\n\nion-card {\n  margin-bottom: 32px;\n\n  ion-card-header {\n    border-bottom: 1px solid #f5f8fa;\n\n    ion-icon {\n      font-size: 20px;\n    }\n  }\n}\n\nul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  color: #a6a9ab;\n\n  li {\n    font-size: 13px;\n  }\n}\n\n.send-mail {\n  ion-button {\n    position: absolute;\n    right: 0;\n    --background: transparent !important;\n  }\n}\n\n.option {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  border: 1px solid #ebeff8;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  padding: 20px;\n  cursor: pointer;\n  border-radius: 13px;\n\n  ion-icon {\n    font-size: 55px;\n    margin-bottom: 40px;\n    color: #404248;\n  }\n\n  ion-label {\n    font-size: 17px !important;\n    font-weight: 600;\n    text-transform: uppercase;\n    text-align: center;\n    color: #404248;\n    width: 70%;\n  }\n\n  &--disabled {\n    cursor: not-allowed;\n\n    ion-icon,\n    ion-label {\n      color: #d5dae5;\n    }\n  }\n}\n\n@media (max-width: 767px) {\n  .container {\n    display: block !important;\n  }\n\n  .data {\n    padding: 16px;\n    width: 100% !important;\n    position: relative !important;\n  }\n\n  .ticket-data {\n    padding: 0;\n    height: unset !important;\n    width: 100% !important;\n    position: relative !important;\n    padding-bottom: env(safe-area-inset-bottom) !important;\n  }\n}\n\n.giftcard {\n  border-radius: 16px;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin: auto;\n  background: linear-gradient(56deg, rgba(35, 107, 254, 1) 35%, rgba(35, 159, 254, 1) 100%);\n  position: relative;\n  margin-top: 16px;\n  margin-bottom: 16px;\n\n  .main-info {\n    h1 {\n      font-weight: 600;\n      color: white;\n      font-size: 35px;\n      letter-spacing: 6px;\n    }\n\n    h2 {\n      font-size: 20px;\n      font-weight: 600;\n      color: white;\n      letter-spacing: 0.5px;\n    }\n\n    p {\n      color: #ffffffbf;\n      font-size: 16px;\n      letter-spacing: 0.5px;\n      margin-bottom: 4px;\n    }\n  }\n\n  .logo {\n    position: absolute;\n    right: 30px;\n    width: 40px;\n    filter: brightness(0) invert(1);\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
